import { Injectable } from '@angular/core';
import { Modal } from 'bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  /**
   * Mostra um modal pelo ID
   */
  showModal(modalId: string): void {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();
    }
  }

  /**
   * Esconde um modal pelo ID
   */
  hideModal(modalId: string): void {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
  }

  /**
   * Alterna a visibilidade de um modal
   */
  toggleModal(modalId: string): void {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      } else {
        const newModalInstance = new Modal(modalElement);
        newModalInstance.show();
      }
    }
  }

  /**
   * Verifica se um modal está aberto
   */
  isModalOpen(modalId: string): boolean {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement);
      return modalInstance !== null;
    }
    return false;
  }

  /**
   * Fecha um modal e abre outro
   */
  switchModal(fromModalId: string, toModalId: string): void {
    this.hideModal(fromModalId);
    setTimeout(() => {
      this.showModal(toModalId);
    }, 100); // Pequeno delay para garantir que o primeiro modal feche
  }

  /**
   * Fecha todos os modais abertos
   */
  hideAllModals(): void {
    const modals = document.querySelectorAll('.modal.show');
    modals.forEach(modal => {
      const modalInstance = Modal.getInstance(modal);
      if (modalInstance) {
        modalInstance.hide();
      }
    });
  }

  /**
   * Obtém uma instância de modal
   */
  getInstance(modalElement: HTMLElement): Modal | null {
    return Modal.getInstance(modalElement);
  }

  /**
   * Cria uma nova instância de modal
   */
  createModal(modalElement: HTMLElement): Modal {
    return new Modal(modalElement);
  }
}
